<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.coolingWaterEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/coolingWaterPara"><span>{{$t('tlt.fm.coolingWater')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/coolingWaterParaEdit"><span>{{$t('tlt.fm.coolingWaterEdit')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('coolingWaterPara')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('coolingWaterPara')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="day"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="time" name="time"> -->
                                <mes-time-picker v-model="time"></mes-time-picker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.furnaceName')}}：</label>
                                <select class="form-control" v-model="furnaceNumber" v-validate="'required'" name="furnaceNumber">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                </select>
                                <span v-show="errors.has('furnaceNumber')" class="lbl-obg">
                                    {{errors.first('furnaceNumber')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.tankPressure')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="tankPressure" name="tankPressure" v-validate="'required'">
                                <span v-show="errors.has('tankPressure')" class="lbl-obg">
                                    {{errors.first('tankPressure')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.tankLiquidLevel')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="tankLiquidLevel" name="tankLiquidLevel" v-validate="'required'">
                                <span v-show="errors.has('tankLiquidLevel')" class="lbl-obg">
                                    {{errors.first('tankLiquidLevel')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.reWaterPressure')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="reWaterPressure" name="reWaterPressure" v-validate="'required'">
                                <span v-show="errors.has('reWaterPressure')" class="lbl-obg">
                                    {{errors.first('reWaterPressure')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.reWaterFlow')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="reWaterFlow" name="reWaterFlow" v-validate="'required'">
                                <span v-show="errors.has('reWaterFlow')" class="lbl-obg">
                                    {{errors.first('reWaterFlow')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow1')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow1" name="flow1" v-validate="'required'">
                                <span v-show="errors.has('flow1')" class="lbl-obg">
                                    {{errors.first('flow1')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure1')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure1" name="pressure1" v-validate="'required'">
                                <span v-show="errors.has('pressure1')" class="lbl-obg">
                                    {{errors.first('pressure1')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow2')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow2" name="flow2" v-validate="'required'">
                                <span v-show="errors.has('flow2')" class="lbl-obg">
                                    {{errors.first('flow2')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure2')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure2" name="pressure2" v-validate="'required'">
                                <span v-show="errors.has('pressure2')" class="lbl-obg">
                                    {{errors.first('pressure2')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow3')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow3" name="flow3" v-validate="'required'">
                                <span v-show="errors.has('flow3')" class="lbl-obg">
                                    {{errors.first('flow3')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure3')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure3" name="pressure3" v-validate="'required'">
                                <span v-show="errors.has('pressure3')" class="lbl-obg">
                                    {{errors.first('pressure3')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow4')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow4" name="flow4" v-validate="'required'">
                                <span v-show="errors.has('flow4')" class="lbl-obg">
                                    {{errors.first('flow4')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure4')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure4" name="pressure4" v-validate="'required'">
                                <span v-show="errors.has('pressure4')" class="lbl-obg">
                                    {{errors.first('pressure4')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow5')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow5" name="flow5" v-validate="'required'">
                                <span v-show="errors.has('flow5')" class="lbl-obg">
                                    {{errors.first('flow5')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure5')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure5" name="pressure5" v-validate="'required'">
                                <span v-show="errors.has('pressure5')" class="lbl-obg">
                                    {{errors.first('pressure5')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.flow6')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="flow6" name="flow6" v-validate="'required'">
                                <span v-show="errors.has('flow6')" class="lbl-obg">
                                    {{errors.first('flow6')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pressure6')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pressure6" name="pressure6" v-validate="'required'">
                                <span v-show="errors.has('pressure6')" class="lbl-obg">
                                    {{errors.first('pressure6')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions, mapState,
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/smelting/CoolingWaterPara";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'coolingWaterPara/getField',
        mutationType: 'coolingWaterPara/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('coolingWaterPara/loadLocations');
    },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.coolingWaterPara.locations,
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>